import search from '../../graphic-charter/icons/search.svg';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';

import { Logo } from '@bloomays-lib/ui.shared';
import { forwardRef } from 'react';

export type SearchBarProps = {
  placeholder: string;
  onChange: (e: any) => void;
  disabled?: boolean;
  ref?: React.RefObject<HTMLInputElement>;
  searchValue?: string;
  variant?: 'talentBoard' | 'default';
};

const CssTextField = styled(TextField, { shouldForwardProp: (prop) => prop !== 'variant' })(
  ({ theme, variant = 'default' }) => ({
    '& .MuiInput-underline:after': {
      borderBottomColor: theme.palette.blue[60],
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: theme.palette.neutral.white,
      },
      '&:hover fieldset': {
        borderColor: theme.palette.blue[60],
      },
      '&.Mui-focused fieldset': {
        border: `1px solid ${theme.palette.blue[60]}`,
      },
      '&.Mui-focused': {
        color: theme.palette.neutral[80],
      },
    },
    '& .MuiInputBase-root': {
      backgroundColor: theme.palette.neutral[10],
      height: variant === 'talentBoard' ? '56px' : '42px',
      color: theme.palette.neutral[80],
      borderRadius: '5px',
      '&.Mui-disabled': {
        backgroundColor: theme.palette.neutral[10],
        color: theme.palette.neutral[20],
      },
      '&.Mui-disabled fieldset': {
        borderColor: 'white',
      },
    },
  }),
);

const SearchBar = forwardRef(
  ({ placeholder, onChange, disabled, searchValue, variant = 'default' }: SearchBarProps, ref: any) => {
    return (
      <CssTextField
        inputRef={ref}
        disabled={disabled}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Logo image={search} />
            </InputAdornment>
          ),
        }}
        size="small"
        placeholder={placeholder}
        value={searchValue}
        onChange={onChange}
        fullWidth
        variant={variant}
      />
    );
  },
);

export default SearchBar;
export { SearchBar };
